import _ from 'lodash'
import prepareData from './prepare-data'
import ChartDesignerTrendLine from '../model/chart-designer-trend-line'

const PERFORMANCE = 'performance'

/**
 * These plot types are totally colored by their performance color when Score
 * Colors is used (unlike, for example, line charts that just color their
 * points).
 */
const PERFORMANCE_COLOR_PLOT_TYPES = [ 'bar', 'process', 'pie', 'donut', 'cycle',
	'timeline', 'funnel', 'pyramid', 'waffle', 'filled-container']

function prepareTableData ({ chart }) {
	let preparedData = prepareData({
		chart,
		chartData: chart.data,
		forChart: false
	})

	let regressionSeriesByDataSerieId = {}

	preparedData.plots.forEach(plot => {
		const firstSerieType = _.get(plot.series, '[0].type')
		if (firstSerieType === 'filled-map') filterBlankValues(plot)

		_.each(plot.series, feature => {
			const featureModel = chart.findFeatureByUnderlyingSerieId(feature)
			feature.underlyingSerie = featureModel
			if (featureModel instanceof ChartDesignerTrendLine) {
				const trendLineSource = featureModel.getSourceSerieId()
				if (trendLineSource) {
					regressionSeriesByDataSerieId[`${trendLineSource}`] = feature
				}
			}
		})

		// #40185 only show "true" serie in the data table (ie not reference
		// lines or bands)
		plot.series = plot.series.filter(s => {
			return _.invoke(s.underlyingSerie, 'isSerie')
		})
	})

	let serieIconColors = []
	if (preparedData.plots.length > 0) {
		serieIconColors = preparedData.plots[0].series.map(serie => {
			return serieIconColor({ chart, serie })
		})
	}

	return { preparedData, regressionSeriesByDataSerieId, serieIconColors }
}

/**
 * filters the ranges and points that correspond to points with blank values
 */
const filterBlankValues = (plot) => {
	if (_.isNil(plot.series[0])) return

	plot.series[0].points = _.filter(plot.series[0].points, p => !!p.raw)
	if (!_.isEmpty(plot.breakdown?.range)) {
		let rangeIdsWithValue = _.map(plot.series[0].points, p => p.rangeId)
		plot.breakdown.range = _.filter(plot.breakdown?.range, r =>
			_.includes(rangeIdsWithValue, r.id))
	}
}

/**
 * #40281 Get the correct color based on what would be rendered on the chart
 * for the provided serie
 *
 * @param {ChartDesigner} chart
 * @param {ChartDataSerie} serie
 */
function serieIconColor ({ chart, serie }) {
	const colorSettings = chart.get('colors').find(s => s.plotType === serie.type)

	switch (_.get(colorSettings, 'colorType')) {
		case null:
		case 'manual': return serie.color
		case 'specific': return colorSettings.specificColor
		case 'score': {
			return _.includes(PERFORMANCE_COLOR_PLOT_TYPES, serie.type)
				? PERFORMANCE : serie.color
		}
		default: return ''
	}
}

export default prepareTableData
export { filterBlankValues }

prepareTableData.__filename__ = 'charts/chart-data/prepare-table-data.js'
